import React, { useState, useEffect } from 'react';

// Tiny app-wide toast system. Call toast('message', 'error' | 'success' | 'info')
// from anywhere; <ToastHost /> (mounted once in App.js) renders the stack.
let listener = null;
let counter = 0;

export function toast(message, type = 'info') {
  if (listener) listener({ id: ++counter, message, type });
}

const COLORS = {
  error: 'var(--red)',
  success: 'var(--green)',
  info: 'var(--orange)',
};

export function ToastHost() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    listener = (t) => {
      setToasts(prev => [...prev.slice(-2), t]); // max 3 on screen
      // Start the exit animation, then remove after it finishes
      setTimeout(() => {
        setToasts(prev => prev.map(x => (x.id === t.id ? { ...x, leaving: true } : x)));
      }, 3600);
      setTimeout(() => {
        setToasts(prev => prev.filter(x => x.id !== t.id));
      }, 3850);
    };
    return () => { listener = null; };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0,
      bottom: 'calc(16px + env(safe-area-inset-bottom))',
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8,
      zIndex: 9999, pointerEvents: 'none', padding: '0 16px',
    }}>
      <style>{`
        @keyframes toastUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
        @keyframes toastDown { from { opacity: 1; transform: none; } to { opacity: 0; transform: translateY(10px); } }
      `}</style>
      {toasts.map(t => (
        <div key={t.id} style={{
          animation: t.leaving ? 'toastDown 0.25s ease both' : 'toastUp 0.2s ease both',
          background: 'var(--bg3)',
          border: '1px solid var(--border)',
          borderLeft: `3px solid ${COLORS[t.type] || COLORS.info}`,
          borderRadius: 10,
          padding: '11px 16px',
          fontSize: 14, fontWeight: 500, color: 'var(--text)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.45)',
          maxWidth: 480, width: 'auto',
          pointerEvents: 'auto',
        }}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
